/// <amd-module name="Wit/Common/Controls/Boards/FocusOnMount" />

import * as React from "react";

/**
 * On mount, search children for a focusable element and focus it.
 */
export function FocusOnMount(props: React.PropsWithChildren<{}>) {
    const childRef = React.useRef<HTMLDivElement>(null);
    React.useEffect(() => {
        const child = childRef.current;
        if (child) {
            const focusable: HTMLElement | null = child.querySelector("input,textarea");
            focusable?.focus();

            // expand any dropdowns that the field has
            focusable?.click();
        }
    }, []);
    return <div ref={childRef}>{props.children}</div>;
}
